"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BehindTheChair() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: galleryRef,
    isVisible: galleryVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const legacyItems = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/precision_haircut_artistry.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/precision_haircut_artistry.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/precision_haircut_artistry.png-wvc-sizes",
    alt: "A stylist performing a precision haircut",
    caption: "—  Precision in every movement",
    aspect: "aspect-[3/4]",
    span: "md:col-span-4 md:row-span-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_process.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_process.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_process.png-wvc-sizes",
    alt: "A vibrant balayage color transformation",
    caption: "—  Sun-kissed tones, hand-painted",
    aspect: "aspect-[4/3]",
    span: "md:col-span-5 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png-wvc-sizes",
    alt: "A behind-the-chair styling session",
    caption: "—  Artistry in the chair",
    aspect: "aspect-square",
    span: "md:col-span-3 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png-wvc-sizes",
    alt: "Close up of hair texture and styling",
    caption: "—  Defining natural beauty",
    aspect: "aspect-square",
    span: "md:col-span-3 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_color_palette.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_color_palette.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_color_palette.png-wvc-sizes",
    alt: "A collection of professional hair color tools",
    caption: "—  Vibrant transformations",
    aspect: "aspect-[4/5]",
    span: "md:col-span-3 md:row-span-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_finishing_touch.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_finishing_touch.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_finishing_touch.png-wvc-sizes",
    alt: "A stylist applying finishing product",
    caption: "—  The final polish",
    aspect: "aspect-[5/4]",
    span: "md:col-span-3 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_conditioning_treatment.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_conditioning_treatment.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_conditioning_treatment.png-wvc-sizes",
    alt: "A deep conditioning treatment session",
    caption: "—  Nourishing every strand",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_cut.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_cut.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_cut.png-wvc-sizes",
    alt: "A modern haircut result",
    caption: "—  Modern, effortless style",
    aspect: "aspect-[3/4]",
    span: "md:col-span-3 md:row-span-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_client_reveal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_client_reveal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_client_reveal.png-wvc-sizes",
    alt: "A happy client after a salon visit",
    caption: "—  Confidence, redefined",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6 md:row-span-1"
  }];
  return <section data-section-id="936" id="behind-the-chair" className="dark bg-background text-foreground py-40 px-6 relative overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(340, 45%, 60%, 0.08) 0%, transparent 60%)"
    }} aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center transition-all duration-[1200ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs uppercase tracking-[0.3em] mb-8" style={{
          color: "var(--chart-1)"
        }}>
            <span className="inline-block mx-2">·</span>
            Behind the Chair
            <span className="inline-block mx-2">·</span>
          </p>

          <h2 className="font-serif font-default font-light text-foreground leading-[1.05] mb-12" style={{
          fontSize: "clamp(2.5rem, 5vw, 4.5rem)"
        }}>
            Artistry in motion.
          </h2>

          <p className="font-serif italic text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" style={{
          color: "hsla(30, 20%, 98%, 0.75)"
        }}>
            "Where precision meets softness, creating a look that is uniquely yours."
          </p>
        </div>

        {}
        <div ref={galleryRef} className={`mt-24 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-6 transition-all duration-[1400ms] ease-out ${galleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {legacyItems.map((item, i) => <figure data-index={i} key={i} className={`group relative overflow-hidden rounded-lg ${item.span}`} style={{
          border: "1px solid hsla(340, 45%, 60%, 0.12)"
        }}>
              <div className={`${i === 7 ? "h-auto" : item.aspect} w-full overflow-hidden`}>
                <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[700ms] ease-out group-hover:scale-[1.04]" style={{
              filter: "sepia(0.05) saturate(1.1) brightness(1.05)"
            }} />
              </div>

              {}
              <div className="pointer-events-none absolute inset-0 opacity-30 group-hover:opacity-20 transition-opacity duration-700" style={{
            background: "linear-gradient(180deg, transparent 50%, hsla(240, 10%, 8%, 0.7) 100%)"
          }} aria-hidden="true" />

              {}
              <figcaption className="absolute bottom-0 left-0 right-0 px-5 py-4 font-serif italic text-sm md:text-base translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[700ms] ease-out" style={{
            color: "hsla(30, 20%, 98%, 0.95)"
          }}>
                {item.caption}
              </figcaption>
            </figure>)}
        </div>

        {}
        <div className="mt-16 flex flex-col items-center text-center gap-6">
          <p className="font-serif italic text-xs md:text-sm" style={{
          color: "hsla(30, 20%, 98%, 0.5)"
        }}>
            Explore our full range of salon services and pricing.
          </p>

          <Link to="/LookbookPage" className="group inline-flex items-center gap-2 font-serif italic text-base md:text-lg transition-colors duration-300 hover:opacity-80" style={{
          color: "var(--chart-1)"
        }}>
            <span className="border-b border-current pb-1">Download our pricing guide</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}